// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"59b7eed467ef0ace","6831":"6bf5884e59d3206f","8503":"aaeac89fad8175fd","9683":"a29bbf5f55c56ccf"}[chunkId] + ".js";
};